import type { ApiResponse } from "@kineslima/types";

const API_URL = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_URL}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "kineslima-web",
      ...init?.headers,
    },
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new ApiError(body?.error ?? "No pudimos completar la solicitud", response.status);
  }

  const payload = (await response.json()) as ApiResponse<T>;
  return payload.data;
}

export function formatDate(value: string, options?: Intl.DateTimeFormatOptions) {
  return new Intl.DateTimeFormat("es-PE", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    ...options,
  }).format(new Date(`${value.slice(0, 10)}T12:00:00`));
}

export function formatNumber(value: number) {
  return new Intl.NumberFormat("es-PE").format(value);
}
